export const CANONICAL_ORIGIN = "https://yohandraespinrealtor.com";

export function absoluteUrl(path: string): string {
  return new URL(path, CANONICAL_ORIGIN).href;
}

export function absoluteImageUrl(path: string): string {
  return absoluteUrl(path);
}
